import React, { useEffect, useState } from "react";
import Client from "shopify-buy";

const Products = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    // const fetchShopifyData = async () => {
    //   try {
    //     const response = await fetch(
    //       "https://kingcobratattoosupplyweb.myshopify.com/admin/api/2023-04/products.json",
    //       {
    //         headers: {
    //           "X-Shopify-Access-Token": "9eb80ba33e911ecbc738c4576de805ff",
    //           "Content-Type": "application/json",
    //         },
    //         changeOrigin: true,
    //         crossDomain: true,
    //       }
    //     );
    //     if (response.ok) {
    //       const data = await response.json();
    //       setProducts(data.products);
    //     } else {
    //       console.log("Error: Unable to fetch Shopify data");
    //     }
    //   } catch (error) {
    //     console.log("Error:", error);
    //   }
    // };
    // fetchShopifyData();
  }, []);

  return (
    <div>
      <h1>Shopify Products</h1>
      <table>
        <thead>
          <tr>
            <th>Title</th>
            <th>Price</th>
            <th>Vendor</th>
          </tr>
        </thead>
        <tbody>
          {products.map((product) => (
            <tr key={product.id}>
              <td>{product.title}</td>
              <td>{product.variants[0].price}</td>
              <td>{product.vendor}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Products;
